import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
export class MultiSelectDropdownModule {
}
MultiSelectDropdownModule.ɵfac = function MultiSelectDropdownModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MultiSelectDropdownModule)(); };
MultiSelectDropdownModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MultiSelectDropdownModule });
MultiSelectDropdownModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, DisabledModule, FormsModule, HelpModalModule, IconModule] });
